<template>
  <div id="app">

    <!-- <div class="ordertips" v-show="this.$store.state.orderopentime && this.$store.state.ordertype == '-PositionOpen' && this.$store.state.ordertipshow">
      <div class="ordercenter">
      <p>【交易提醒】</p>
      <p>您于{{getTime(this.$store.state.orderopentime)}}以{{this.$store.state.orderopenprice}}的价格{{this.$store.state.orderdeal==0?'买入':(this.$store.state.orderdeal==1?'卖出':'')}}{{this.$store.state.ordersymbol =='XAU' || this.$store.state.ordersymbol =='GOLD'?'伦敦金':(this.$store.state.ordersymbol =='XAG' || this.$store.state.ordersymbol =='SILVER'?'伦敦银':'')}}{{this.$store.state.orderlots}}手订单号为{{this.$store.state.orderticket}}</p>
      </div>
    </div>

    <div class="ordertips" v-show="this.$store.state.orderclosetime && this.$store.state.ordertype == '-PositionClose' && this.$store.state.ordertipshow">
      <div class="ordercenter">
      <p>【交易提醒】</p>
      <p>您的订单号为{{this.$store.state.orderticket}}的订单于{{getTime(this.$store.state.orderclosetime)}}以{{this.$store.state.ordercloseprice}}的价格平仓{{this.$store.state.ordersymbol =='XAU' || this.$store.state.ordersymbol =='GOLD'?'伦敦金':(this.$store.state.ordersymbol =='XAG' || this.$store.state.ordersymbol =='SILVER'?'伦敦银':'')}}{{this.$store.state.orderlots}}手</p>
      </div>
    </div>

    <div class="ordertips" v-show="this.$store.state.ordertype == '-PendingOpen' && this.$store.state.ordertipshow">
      <div class="ordercenter">
      <p>【交易提醒】</p>
      <p>您于{{getTime(this.$store.state.orderopentime)}}以{{this.$store.state.orderopenprice}}的价格{{this.$store.state.orderdeal==2?'委托买入':''}}{{this.$store.state.ordersymbol =='XAU' || this.$store.state.ordersymbol =='GOLD'?'伦敦金':(this.$store.state.ordersymbol =='XAG' || this.$store.state.ordersymbol =='SILVER'?'伦敦银':'')}}{{this.$store.state.orderlots}}手订单号为{{this.$store.state.orderticket}}</p>
      </div>
    </div>

    <div class="ordertips" v-show="this.$store.state.ordertype == '-PendingClose' && this.$store.state.ordertipshow">
      <div class="ordercenter">
      <p>【交易提醒】</p>
      <p>您的订单号为{{this.$store.state.orderticket}}的委托单于{{getTime(this.$store.state.orderclosetime)}}撤单成功</p>
      </div>
    </div> -->

    <!-- wstips -->
    <div class="wstips">
      <div class="item" style="animation: fadeout 1s ease;" v-show="falseconnect"><p><img src="@/assets/wsicon01.png" alt=""> 重连服务器失败，请检查您的网络</p></div>
      <div class="item" style="animation: fadeout 1s ease;" v-show="successconnect"><p><img src="@/assets/wsicon02.png" alt=""> 连接服务器成功</p></div>
      <div class="item" style="animation: fadeout 1s ease;" v-show="connecting"><p><img src="@/assets/wsicon03.png" style="animation:loading 0.75s linear infinite forwards;" alt=""> 正在尝试重连服务器</p></div>
    </div>

    <router-view v-if="isRouterAlive"></router-view>

  </div>
</template>

<script>
import pako from 'pako'
import {login0,getsymbol,sendText0,start,utf8ByteToUnicodeStr,toBytes,encode} from '@/utils/socket2.js';
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
export default {
  name: 'App',
  provide(){ //定义刷新当前页面
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true,//定义刷新当前页面
      falseconnect:false,//重连失败提示
      successconnect:false,//连接成功提示
      connecting:false,//正在重连提示

      ismobile:false,//手机端
      ispc:false,//PC端

      oncereload:false,//刷新之后重载页面只重载一次
    }
  },

    methods: {

      reload(){
        this.isRouterAlive = false
        this.$nextTick(function(){
          this.isRouterAlive = true
        })
      },

        // 判断是否手机端
        isMobile() {
          let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
          return flag;
        },

        initWebpack(){
          var that = this

          that.$store.state.dealgold = sessionStorage.getItem('reloaddealgold') //刷新之后重新赋值挂单商品
          that.$store.state.mt = sessionStorage.getItem("mt")//刷新之后重新赋值当前是否MT5

          // 根据重新赋值挂单商品判断是否专业者
          if(that.$store.state.dealgold == 'XAU'){
            that.$store.state.isprofession = true
          }else if(that.$store.state.dealgold == 'GOLD'){
            that.$store.state.isprofession = false
          }

          //在页面加载时读取sessionStorage里的状态信息
          if (JSON.parse(sessionStorage.getItem("store"))) { //此时刷新之后的login为true,刷新之前如果是真实账户

            
            var wsImpl = window.WebSocket || window.MozWebSocket;


                if(localStorage.getItem('loginUser').slice(0,2) == '20'){
                      that.ws = new wsImpl(that.$store.state.ws20); //创建一条websocket
                      that.global.setWs(that.ws) //保存到全局

      
                  }else if(localStorage.getItem('loginUser').slice(0,2) == '30'){
                      that.ws = new wsImpl(that.$store.state.ws30); //创建一条websocket
                      that.global.setWs(that.ws) //保存到全局

             
                  }else if(localStorage.getItem('loginUser').slice(0,2) == '51'){
                      that.ws = new wsImpl(that.$store.state.ws51); //创建一条websocket
                      that.global.setWs(that.ws) //保存到全局

                     
                  }else if(localStorage.getItem('loginUser').slice(0,2) == '11'){
                      that.ws = new wsImpl(that.$store.state.ws20); //创建一条websocket
                      that.global.setWs(that.ws) //保存到全局

                      
                  }else if(localStorage.getItem('loginUser').slice(0,2) == '70'){
                      that.ws = new wsImpl(that.$store.state.ws70); //创建一条websocket
                      that.global.setWs(that.ws) //保存到全局

             
                  }

                that.global.ws.onopen = function() {
                    that.starts() //发送心跳给后端
                    
                    login0(that.global.ws,localStorage.getItem('loginUser'),localStorage.getItem('loginPwd')) //发送真实账户地址
                }
                that.global.ws.onmessage = function(){

                  that.$store.state.login = true //保存登录状态方便其他页面使用
                  that.$store.state.mnlogin = false //保存登录状态方便其他页面使用

                  sessionStorage.removeItem("mnstore") //刷新之后如果是真实账户，模拟账户变false(清除，等刷新之前会重新获取当前登录状态)

                  that.$store.state.realcorrectshow = true //登录真实账号对应头部导航

                  that.$store.state.mncorrectshow = false //控制图标

                  if(!that.oncereload){
                    that.reload() //这里刷新是因为，刷新浏览器之后，其他页面已经加载了此时页面socket没有连接所以空白，刷新展示数据
                    that.oncereload = true //只允许刷新一次
                  }

                },
                that.global.ws.onclose = function() {
                    
                    if(that.global.ws){
                        that.global.ws = null
                    }

                    sessionStorage.removeItem("mnstore") //清除模拟账户状态等待重连

                    setTimeout(() => {
                      that.initWebpack()
                    }, 1500)
                }

          }
          
          if (JSON.parse(sessionStorage.getItem("mnstore"))) { //此时刷新之后的mnlogin为true,刷新之前如果是模拟账户
            
            
            var wsImpl = window.WebSocket || window.MozWebSocket;

                that.ws = new wsImpl(that.$store.state.mnws); //创建一条websocket
                that.global.setWs(that.ws) //保存到全局

                

                that.global.ws.onopen = function() {
                    that.starts() //发送心跳给后端
                    
                    login0(that.ws,localStorage.getItem('mnloginUser'),localStorage.getItem('mnloginPwd')) //发送模拟账户请求服务端
                }
                that.global.ws.onmessage = function(){

                  that.$store.state.login = false //保存真实账户状态方便其他页面使用
                  that.$store.state.mnlogin = true //保存模拟账户状态方便其他页面使用

                  sessionStorage.removeItem("store") //刷新之后如果是模拟账户状态，真实账户为false(清除，等刷新之前会重新获取当前登录状态)

                  that.$store.state.realcorrectshow = false //登录图标

                  that.$store.state.mncorrectshow = true //登录模拟账号对应头部导航


                  if(!that.oncereload){
                    that.reload() //这里刷新是因为，刷新浏览器之后，其他页面已经加载了此时页面socket没有连接所以空白，刷新展示数据
                    that.oncereload = true //只允许刷新一次
                  }
                },
                that.global.ws.onclose = function() {

                    
                    if(that.global.ws){
                        that.global.ws = null
                    }

                    sessionStorage.removeItem("store") //清除真实账号状态等待重连

                    setTimeout(() => {
                      that.initWebpack()
                    }, 1500)
                }

          }

          //在页面刷新时将vuex里的信息保存到sessionStorage里

          if(that.ismobile){
            
            window.addEventListener('pagehide', () => {
              let state = JSON.stringify(that.$store.state.login) //刷新之前保存账户真实状态
              let mnstate = JSON.stringify(that.$store.state.mnlogin) //刷新之前账户模拟状态

              sessionStorage.setItem("store", state == null ? '' : state) //保存的账户真实状态存本地
              sessionStorage.setItem("mnstore", mnstate == null ? '' : mnstate) //保存的账户模拟状态存本地

              let dealgold = that.$store.state.dealgold //保存挂单商品
              sessionStorage.setItem("reloaddealgold", dealgold == null ? '' : dealgold)//保存挂单距离

              let mt = that.$store.state.mt //保存当前是否MT5
              sessionStorage.setItem("mt",mt?mt:null)
            })

          }else if(that.ispc){
            
            window.addEventListener("beforeunload", () => {
              let state = JSON.stringify(that.$store.state.login) //刷新之前保存账户真实状态
              let mnstate = JSON.stringify(that.$store.state.mnlogin) //刷新之前账户模拟状态

              sessionStorage.setItem("store", state == null ? '' : state) //保存的账户真实状态存本地
              sessionStorage.setItem("mnstore", mnstate == null ? '' : mnstate) //保存的账户模拟状态存本地

              let dealgold = that.$store.state.dealgold //保存挂单商品
              sessionStorage.setItem("reloaddealgold", dealgold == null ? '' : dealgold)//保存挂单距离

              let mt = that.$store.state.mt //保存当前是否MT5
              sessionStorage.setItem("mt",mt?mt:null)

            })
          }

        },

        //在onopen开始之后直接进行f方法调用 数据数据发送
        starts() { // 发送心跳
            clearInterval(this.timeoutObj)
            this.timeoutObj = setInterval(() => {
                let that = this;
                let date = new Date()        
                if (that.global.ws && that.global.ws.readyState == 1) {
                    
                    that.global.ws.send(`发送心跳给后端${date}`);
                }
            }, 2 * 60 * 1000)
        },

    },

    created(){

      if (this.isMobile()) {
        this.ismobile = true
      } else {
        this.ispc = true
      }
    },

    mounted(){
      this.initWebpack() //用户刷新重载数据,刷新页面之前数据存储到sessionStorage用法,当需要刷新页面获取数据时开启。
    },

}
</script>

<style>
*{margin: 0;padding: 0;}
body{background-color: #F5F5F5;touch-action: none;}

/* 订单推送tips */
.ordertips{width: 100%;border-radius: 12px; position: fixed;top: 5px;left: 0;right: 0;margin: 0 auto;border-radius: 6px;background-color: #F5F5F5;z-index: 999999999999;font-size: 14px;color: #333333;display: flex;flex-direction: column; animation: topIn 1s ease;}
.ordercenter{padding: 12px 12px;}
.ordercenter p:nth-of-type(1){padding-bottom: 5px;}

/* wstips */
.wstips{width: 100%;position: fixed;bottom: 20px;left: 0;right: 0;margin: 0 auto;z-index: 999999999999;}
.wstips .item{width: 100%; border-radius: 12px;margin-bottom: 12px;background-color: #FFEDEB;}
.wstips .item p{display: flex;align-items: center;color: #FF4F36;font-size: 14px;padding: 10px 0 10px 12px;}
.wstips .item img{width: 24px;height: 24px;display: block;}

@keyframes topIn {
0% {
    opacity: 0;
    transform: translateY(-50px);
}
100% {
    opacity: 1;
    transform: translateY(0);
}
}

@keyframes fadeout {
0% {
    opacity: 1;
    transform: translateY(0);
}
100% {
    opacity: 0;
    transform: translateY(-50px);
}
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue